<template>
  <v-row shrink>
    <v-flex shrink>
      <v-currency-field
          type="number"
          v-bind="currency_config"
          :min="0"
          class="small-text-field"
          :required="required"
          :value="content"
          :label="label"
          :placeholder="label"
          height="28"
          @input="updateSelf"
          :error-messages="valid == true ? null : [valid]"
          :hide-details="valid == true"
          outlined
          dense
          :style="{'width': width }"
          v-model="content"
      >></v-currency-field>
    </v-flex>
    <v-flex shrink v-if="content != null">
      <v-btn class="small-fab" icon @click="content=null">
        <v-icon>close</v-icon>
      </v-btn>
    </v-flex>
  </v-row>
</template>

<script>
export default {
  name: "SimpleCurrencyInput",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    content: Number,
    error: String,
    solo: {
      type: Boolean,
      default: true
    },
    singleLine: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: true
    },
    backgroundColour: {
      type: String,
      default: "grey lighten-3"
    },
    extraLabel: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: "80px"
    }
  },
  data() {
    return {
      menu: false,
      required: false,
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true
      }
    };
  },
  computed: {
    valid() {
      if (this.error == null || this.error.length == 0) {
        return true;
      }

      return this.error;
    }
  },
  methods: {
    clear() {
      console.log("Clear");
      this.$emit("clear");
    },
    updateSelf(content) {
      this.menu = false;

      this.$emit("input", this.content);
      console.log("Currency input updated");
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.small-fab {
  transform: scale(0.8);
  transform-origin: bottom;
}
</style>
